export default __webpack_public_path__ + "static/media/notification.0d7c72fc.aac";